import {useState} from 'react'
import useMessage from '@hooks/useMessage'
import {useTranslation} from 'next-i18next'

export default function useOnSubmitHandlers() {
  const [isSubmitting, setSubmitting] = useState(false)
  const showMessage = useMessage()

  const {t} = useTranslation('checkoutv3', {keyPrefix: 'payment.tip'})

  const onError = err => {
    setSubmitting(false)
    showMessage(err)
  }

  const onSuccess = () => {
    setSubmitting(false)
    showMessage(t('tipSaved'))
  }

  const onSubmit = () => {
    setSubmitting(true)
  }

  return {onSubmit, onError, onSuccess, isSubmitting}
}
